import React, { useState } from "react";
import {
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
} from "@material-ui/core";
import * as Icons from "react-bootstrap-icons";
import Translator from "Languages/Utility/Translator";
import MuiButton from "Components/MuiButton/MuiButton";
import { satc_paymentDetailsColumn } from "Constants/TableColumns";
import PaymentTable from "Components/PaymentTable/PaymentTable";
import { useTranslation } from "react-i18next";
import addNumToList from "Helpers/addNumToList";
import showNotify from "Helpers/Notify";
import AccountService from "Services/http/endpoints/superadmin/AccountsEndpoints";
import StatusHandler from "Helpers/StatusHandler";
import InnerCircularProgress from "Components/InnerCircularProgress/InnerCircularProgress";
import { useTheme } from "@material-ui/core/styles";
import DialogHead from "Components/DialogHead/DialogHead";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import { read } from "Helpers/LocalStorage";
import { convertToEnglishNumber } from "Helpers/convertToEnglishNumber";

export default function PayTool({
  show,
  GroupId,
  GroupName,
  data,
  dataRequest,
  backFunc,
}) {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [showDialog, setShowDialog] = useState(show);
  const [credit, setCredit] = useState(0);

  const onEnter = async () => {
    setLoading(true);
    await getCreditAmount();
    setLoading(false);
  };

  const getCreditAmount = async () => {
    const credit_response = await AccountService.getAccountGroupInfo({
      KeyGroup: read("groupAKey"),
      KeyUser: read("userAKey"),
      GroupId,
    });
    if (!StatusHandler(credit_response).isFail) {
      setCredit(credit_response.data.Value.Credit);
    }
  };

  const onFinish = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await AccountService.postUpgradeFinal({
        ...dataRequest,
        TypePayment: 2,
      });
      let err = StatusHandler(response);
      if (!err.isFail) {
        if (response.data.Value.IsError === true) {
          showNotify({
            text: response.data.Value.Describ,
            customClass: "error",
          });
        } else {
          if (response.data.Value.Describ !== "")
            showNotify({
              text: response.data.Value.Describ,
              customClass: "success",
            });
          else
            showNotify({
              text: t("mission_accomplished"),
              customClass: "success",
            });
          onExit();
          backFunc("submit");
        }
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
    setTimeout(() => {
      setLoading(false);
    }, 500);
  };

  const onExit = () => {
    setLoading(false);
    setShowDialog(false);
  };

  const chargeAccount = async () => {
    setLoading(true);
    const response = await AccountService.postAccountingManualCredit({
      KeyGroup: read("groupAKey"),
      KeyUser: read("userAKey"),
      TypeId: 9,
      MethodId: 4,
      Price: +convertToEnglishNumber(data.PriceShow),
      GroupId,
      Describ: "شارژ اتوماتیک در زمان افزایش جزییات فاکتور",
    });
    let err = StatusHandler(response);
    if (!err.isFail) {
      if (response.data.Value.IsError === true) {
        showNotify({ text: response.data.Value.Describ, customClass: "error" });
      } else {
        await getCreditAmount();
        showNotify({ text: t("mission_accomplished"), customClass: "success" });
      }
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  return (
    <>
      <Dialog
        dir={direction}
        open={showDialog}
        onClose={onExit}
        TransitionProps={{
          onEnter: onEnter,
          onExit: onExit,
        }}
        fullWidth
        maxWidth="md"
      >
        <DialogHead
          text={<Translator id="factorsIncreaseDetails" />}
          subtext={GroupName}
          icon={<Icons.Receipt />}
        />
        <DialogContent className="p-0">
          {!loading ? (
            <Grid container className="pb-2">
              <RemoteTable
                data={addNumToList(data.Items)}
                columns={satc_paymentDetailsColumn}
                showPagination={false}
              />
              <Grid item xs={12} className="paymentSection wm">
                <p>
                  <Chip label={t("totalAmounts")} />
                  <strong>{data.PriceCalcList.toLocaleString()}</strong>
                  <Translator id="moneyUnit" />
                </p>
                <p>
                  <Chip label={t("userIncreaseDetailDiscount")} />
                  <strong>{data.GiftCalcPrice.toLocaleString()}</strong>
                  <Translator id="moneyUnit" />
                </p>
                <p>
                  <Chip label={t("userIncreaseDetailPriceShow")} />
                  <strong>{data.PriceShow.toLocaleString()}</strong>
                  <Translator id="moneyUnit" />
                </p>
                <p className="credit-show">
                  <Translator id="priceCredit" />
                  <strong>{credit.toLocaleString()}</strong>
                  <Translator id="moneyUnit" />
                </p>
              </Grid>
            </Grid>
          ) : (
            <InnerCircularProgress />
          )}
        </DialogContent>
        <DialogActions>
          <MuiButton
            className="px-4"
            color="primary"
            title={`شارژ کیف پول به مبلغ ${data.PriceShow.toLocaleString()} ریال`}
            onClick={chargeAccount}
            loading={loading}
            hidden={!(data.PriceShow > credit)}
          />
          <MuiButton
            className="MuiButton-root MuiButtonDanger px-4"
            color="secondary"
            title={<Translator id="payByCredit" />}
            onClick={onFinish}
            disabled={loading}
          />
          <MuiButton
            title={<Translator id="close" />}
            onClick={() => {
              setShowDialog(false);
              backFunc("close");
            }}
            disabled={loading}
          />
        </DialogActions>
      </Dialog>
    </>
  );
}
